import React, { useEffect, useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { BaseDialog } from '@components/common/BaseDialog.tsx';
import { ModalIndices } from '../../../common/i-doc/i-doc.registry.ts';
import { Feature } from './FeaturesTab';

const KEY_PATTERN = /^[a-z][a-z0-9_]*$/;

interface FeatureFormDialogProps {
  open: boolean;
  feature: Feature | null;
  onClose: () => void;
  onSubmit: (values: { key: string; name: string; description: string }) => Promise<void>;
}

export const FeatureFormDialog: React.FC<FeatureFormDialogProps> = ({ open, feature, onClose, onSubmit }) => {
  const [key, setKey] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setKey(feature?.key ?? '');
      setName(feature?.name ?? '');
      setDescription(feature?.description ?? '');
    }
  }, [open, feature]);

  const keyError = !feature && key.length > 0 && !KEY_PATTERN.test(key)
    ? 'snake_case, латиниця, починається з літери'
    : '';
  const canSubmit = name.trim().length > 0 && (feature || (key.trim().length > 0 && !keyError));

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await onSubmit({ key, name: name.trim(), description: description.trim() });
    } finally {
      setSaving(false);
    }
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={feature ? 'Редагувати можливість' : 'Нова можливість'}
      iDoc={ModalIndices.ENTITLEMENTS_FEATURE_FORM}
      actions={
        <Button variant="contained" disabled={!canSubmit || saving} onClick={handleSubmit}>
          Зберегти
        </Button>
      }
    >
      <Box display="flex" flexDirection="column" gap={2} sx={{ pt: 1 }}>
        <TextField
          label="Ключ"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          disabled={!!feature}
          error={!!keyError}
          helperText={keyError || 'Опаковий технічний ідентифікатор, напр. calc_mortgage. Незмінний після створення.'}
          fullWidth
        />
        <TextField
          label="Назва"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
        <TextField
          label="Опис"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          minRows={2}
          fullWidth
        />
      </Box>
    </BaseDialog>
  );
};
